export default __webpack_public_path__ + "locales/si/OAuth.json?hash=03ee35f5b631d54905b60953923de8e0";